export default function($) {

  $("#contact-form #postalcode")
    .keyup(delay_keyup(handlePostalCodeInput, 300))
    .on('click', handlePostalCodeInput);


  function handlePostalCodeInput() {
    var search_postcode = $(this).val();

    if (search_postcode != "" && search_postcode.length >= 3 && search_postcode.length <= 5) {
      autocomplete_postcode(search_postcode);
    } else {
      $("#contact-form #search-postcode").empty();
      $("#contact-form #search-postcode").css('display', 'none');
    }
  }

  function autocomplete_postcode(search_postcode) {
    $("#contact-form #search-postcode").empty();

    $.ajax({
      url:"/contact/search_postcode",
      method:"POST",
      data:{search_postcode:search_postcode},
      success:function(data)
      {
        $("#contact-form #search-postcode").append(data);
      }
    });

    $("#contact-form #search-postcode li").bind("click", function () {
      set_city_by_postcode(this);
    });
  }

  /** See https://stackoverflow.com/questions/1909441/how-to-delay-the-keyup-handler-until-the-user-stops-typing#answer-1909508 to delay events */
  function delay_keyup(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  $(document).click(function(event) {
    if (!$(event.target).closest('#contact-form #search-postcode').length) {
      if ($('#contact-form #search-postcode').is(":visible")) {
        $("#contact-form #search-postcode").css('display', 'none');
      }
    }
  });

  function set_city_by_postcode(element){
    var value = $(element).text();
    var selected_city = value.split(" - ")[1]

    $("#contact-form #postalcode").val(value);
    $("#contact-form #selected_city").val(selected_city);

    $("#contact-form #search-postcode").empty();
    $("#contact-form #search-postcode").css('display', 'none');
    $('#error-selected-city').addClass('hidden');
  }

  $( document ).on( "ajaxComplete", function() {
    if ( $("#contact-form #search-postcode li").length > 0 ) {
      $("#contact-form #search-postcode").css('display', 'block');
    }

    if ( $("#contact-form #search-postcode li").length < 4 ) {
      if ( $("#contact-form #search-postcode li").length == 3 ) {
        $("#contact-form #search-postcode").css("max-height","121px");
        $("#contact-form #search-postcode").css("bottom","-121px");
      } else if ( $("#contact-form #search-postcode li").length == 2 ) {
        $("#contact-form #search-postcode").css("max-height","81px");
        $("#contact-form #search-postcode").css("bottom","-81px");
      } else if ( $("#contact-form #search-postcode li").length == 1 ) {
        $("#contact-form #search-postcode").css("max-height","41px");
        $("#contact-form #search-postcode").css("bottom","-41px");
      } else {
        $("#contact-form #search-postcode").css('display', 'none');
      }
    } else {
      $("#contact-form #search-postcode").css("max-height","161px");
      $("#contact-form #search-postcode").css("bottom","-161px");
    }

    $("#contact-form #search-postcode li").bind("click", function () {
      set_city_by_postcode(this);
    });
  } );
}
